import { createContext, useContext } from 'react';
import type { Location } from './LocationContext';

interface LocationContextValue {
  currentLocation: Location | null;
  locations: Location[];
  setCurrentLocation: (location: Location) => void;
  setLocations: (locations: Location[]) => void;
}

export const LocationContext = createContext<LocationContextValue>({
  currentLocation: null,
  locations: [],
  setCurrentLocation: () => {},
  setLocations: () => {},
});

export function useLocationContext() {
  return useContext(LocationContext);
}
